import { axiosPrivate } from "api/axiosCore";
import { io } from "socket.io-client";

// Create a socket.io instance without connecting immediately
export const socketIO = io(`${process.env.REACT_APP_SOCKET_ADDRESS}`, {
  cors: {
    origin: process.env.REACT_APP_CLIENT_ADDRESS ?? 'http://localhost:3000', // Replace with your client's origin
    methods: ['GET', 'POST']
  },
  path: "/socket.io/",
  transports: ["websocket"],
  autoConnect: false  // Prevent automatic connection
});

// Function to connect with authentication
export async function connectWithAuth(token) {
  try {

    // Fetch the WebSocket token
    const wsAuth = await fetchWebSocketToken(token);
    
    // Set the auth options with the token
    socketIO.auth = {
      Authorization: `Bearer ${wsAuth.data.token}`
    };
    
    // Set the extraHeaders for the initial handshake
    // Note: This approach may not work for all Socket.IO versions
    if (socketIO.io && socketIO.io.opts) {
      socketIO.io.opts.extraHeaders = {
        Authorization: `Bearer ${wsAuth.data.token}`
      };
    }
    
    // Connect to the socket
    socketIO.connect();
    
    return socketIO;
  } catch (error) {
    console.error("Failed to connect with authentication:", error);
    throw error;
  }
}

export const fetchWebSocketToken = async (token) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });
    const query = "/api/user-sockets/tokens";
    const response = await axiosPrivate.get(query);
    
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};